import { TableCell } from "@mui/material";
import {
  IStepSubOrdersTableReport,
} from "../../../Interfaces/stepInterfaces";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { useState } from "react";
import SubOrderChancesTable from "./SubOrderDetail/ShekarSubOrderChancesTable";
import BrokerOrdersTable from "../BrokerOrder/BrokerOrdersTable";
import { getBrokerOrdersTable } from "../../../Requests/stepRequests";
import { OrderStrategy } from "../../../Interfaces/orderInterfaces";
import CompetitionSubOrderChancesTable from "./SubOrderDetail/CompetitionSubOrderChancesTable";

const SubOrdersTableAdditionalHeader = () => {
  return (
    <>
      <TableCell></TableCell>
    </>
  );
};

const SubOrdersTableAdditionalCol: React.FC<{
  row: IStepSubOrdersTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isChancesModalOpen, setIsChancesModalOpen] = useState(false);

  const getChancesModalUI = () => {
    switch (row.orderStrategy) {
      case OrderStrategy.Hunt:
        return <SubOrderChancesTable shekarOrderId={row.shekarOrderId} />;

      case OrderStrategy.StepCompetition:
        return <CompetitionSubOrderChancesTable orderId={row.id} />;

      default:
        return <></>;
    }
  };

  const getBrokersTableModalUI = () => {
    switch (row.orderStrategy) {
      case OrderStrategy.Hunt:
        return (
          <BrokerOrdersTable
            getData={getBrokerOrdersTable}
            shekarOrderId={row.shekarOrderId}
          />
        );

      case OrderStrategy.StepCompetition:
        return (
          <BrokerOrdersTable getData={getBrokerOrdersTable} orderId={row.id} />
        );

      default:
        break;
    }
  };

  return (
    <>
      <TableCell>
        {isDetailsModalOpen ? (
          <Modal
            UI={getBrokersTableModalUI()}
            onClose={() => setIsDetailsModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsDetailsModalOpen(true)}
          text="جزییات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {row.orderStrategy === OrderStrategy.Hunt ? (
          <>
            {isChancesModalOpen ? (
              <Modal
                UI={getChancesModalUI()}
                onClose={() => setIsChancesModalOpen(false)}
              />
            ) : null}
            <Button
              onClick={() => setIsChancesModalOpen(true)}
              text="شانس ها"
              variant="contained"
              className="table-btn"
            />
          </>
        ) : (
          <></>
        )}
      </TableCell>
    </>
  );
};

export const SubOrdersTableAdditional: IAdditional<IStepSubOrdersTableReport> =
  {
    getHeader: SubOrdersTableAdditionalHeader,
    getRow: SubOrdersTableAdditionalCol,
  };
